export default __webpack_public_path__ + "static/media/jangwon_nft_12.ce1ae007.svg";